import {
  PendingRecharge,
  PendingRechargeObject
} from '@/modules/collections/pendingRecharges/types/PendingRecharge.ts'
import { appConfig } from '@/config/app.ts'
import { NestedFilterObject } from '@/core/hooks/useFiltersInBody.ts'

export interface PendingRechargeState {
  isLoading: boolean
  pendingRecharges: PendingRecharge[]
  pendingRecharge: PendingRechargeObject | null
  editId: string | null
  filters: NestedFilterObject
  isLoadingAction: boolean
}

export const initialState: PendingRechargeState = {
  isLoading: false,
  pendingRecharges: [],
  pendingRecharge: null,
  editId: null,
  filters: {
    page: 0,
    limit: appConfig.pagination.defaultValue,
    manualReview: true,
    transactionStatus: 'PENDING'
  },
  isLoadingAction: false
}
